import {  useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers } from "../../controller/users/usersController"
import { AllUsersContainer, SearchContainer } from "../../components";

const Accounts = (props) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAllUsers())
    },[]);

    return (
    <div>
        <AllUsersContainer/>
    </div>
    )
};
export default Accounts;